import * as React from 'react';
import { Button, Col, Form, Modal, ModalProps, Row } from 'react-bootstrap';

type Props = {
  onAdd: (value: { name: string }) => void;
  loading: boolean;
  /** Prefilled name, e.g. the source event's name when cloning. */
  defaultName?: string;
  submitLabel?: string;
  /** Shown under the field when the action needs a word of warning. */
  note?: string;
} & ModalProps;
function AddChainedOfferModal({ show, onHide, onAdd, loading, defaultName, submitLabel, note }: Props) {
  // @ts-ignore
  const handleSubmit = (event) => {
    // Prevent trigger other forms
    event.preventDefault();
    event.nativeEvent.stopImmediatePropagation();

    const { value } = event.target.elements.namedItem('chainedOfferName');

    onAdd({ name: value });
  };

  /**
   * VIEW
   */
  return (
    <Modal show={show} onHide={onHide} onSubmit={handleSubmit}>
      <Modal.Body>
        <Form>
          <Row>
            <Col xs={4}>ChainedOffer Name</Col>
            <Col xs={6}>
              <Form.Group controlId="chainedOfferName">
                {/* keyed on the prefill so reopening the modal for another event refills the field */}
                <Form.Control key={defaultName} required type="text" defaultValue={defaultName} />
              </Form.Group>
            </Col>
          </Row>
          {note && (
            <Row className="pl-1">
              <Col>
                <small className="text-muted">{note}</small>
              </Col>
            </Row>
          )}
          <Row className="mt-3 pl-1">
            <Button disabled={loading} type="submit">
              {submitLabel ?? 'Create'}
            </Button>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default AddChainedOfferModal;
